import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import type { ColumnDef } from '@tanstack/react-table'
import { Plus } from 'lucide-react'
import { useMemo } from 'react'

import { Cell, DataTable, useDataTable } from '@/components/block/data-table'
import { PageLayout } from '@/components/layout'
import { Button } from '@/components/ui/button'

import { DeviceStatusBadge } from '@/features/outlet/components/badge'
import { outletDeviceApi } from '@/features/outlet/outlet-api'
import type { DeviceItemDto } from '@/features/outlet/schema'

import { useAuth } from '@/lib/auth'

export const Route = createFileRoute('/_app/outlet/device/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <PageLayout>
      <PageLayout.Header
        title='Daftar Perangkat'
        action={
          <Button asChild>
            <Link from={Route.fullPath} to='/outlet/device/create'>
              <Plus /> Tambah Perangkat
            </Link>
          </Button>
        }
      />
      <DeviceTable />
    </PageLayout>
  )
}

function DeviceTable() {
  const outletId = useAuth().outlet.oId
  const dvcQry = useQuery(outletDeviceApi.list.query({ params: { outletId } }))

  const columns = useMemo(getColumns, [])
  const table = useDataTable({
    columns,
    data: dvcQry.data?.data.devices ?? [],
    isLoading: dvcQry.isLoading,
  })

  return (
    <DataTable.Root table={table}>
      <DataTable.Table />
      <DataTable.Pagination />
    </DataTable.Root>
  )
}

function getColumns(): ColumnDef<DeviceItemDto>[] {
  return [
    {
      accessorKey: 'name',
      header: 'Perangkat',
      cell: ({ row }) => (
        <Cell.Link
          from={Route.fullPath}
          to='/outlet/device/$id/update'
          params={{ id: row.original.id }}
        >
          {row.original.name}
        </Cell.Link>
      ),
    },
    {
      accessorKey: 'type',
      header: 'Jenis',
      cell: ({ row }) => <Cell.Text text={row.original.type} />,
    },
    {
      accessorKey: 'code',
      header: 'Code',
      cell: ({ row }) => <Cell.Text text={row.original.code} />,
    },
    {
      accessorKey: 'desc',
      header: 'Desc',
      cell: ({ row }) => <Cell.Text text={row.original.desc} />,
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ row }) => <DeviceStatusBadge type={row.original.status} />,
    },
    // {
    //   id: 'action',
    //   cell: ({ row }) => <Action {...row} />,
    // },
  ]
}

// function Action({ original }: Row<DeviceItemDto>) {
//   const { id, name } = original
//   const prompt = usePrompt()

//   const { mutateAsync: remove } = useMutation({
//     mutationFn: outletDeviceApi.remove.fetch,
//   })

//   const onRemove = async () => {
//     const res = await prompt({
//       title: 'Hapus perangkat',
//       description: `Perangkat ${name} akan dihapus.`,
//     })

//     if (res) {
//       toastManager.promise(remove({ params: { id } }), buildToastMessage('delete', 'perangkat'))
//     }
//   }

//   return (
//     <div>
//       <DropdownMenu>
//         <DropdownMenu.Trigger >
//             <DotsVerticalIcon />
//         </DropdownMenu.Trigger>
//         <DropdownMenu.Content>
//           <DropdownMenu.Item onClick={onRemove}>Delete</DropdownMenu.Item>
//         </DropdownMenu.Content>
//       </DropdownMenu>
//     </div>
//   )
// }
